import { render, staticRenderFns } from "./formPermohonanBerusaha.vue?vue&type=template&id=40587882&"
import script from "./formPermohonanBerusaha.vue?vue&type=script&lang=js&"
export * from "./formPermohonanBerusaha.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports